import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dropdown, Table, Button, Checkbox } from 'semantic-ui-react';
import i18next from 'i18next';

import { DataGrid } from '../../../common';

import { fetchRestaurantSalesData, setEditedEntity } from '../../../../actions';
import { formatPrice } from '../../../../helpers/format';

class RestaurantsPaymentsReport extends Component {

    constructor(props) {
        super(props);

        this.prepareInvoice = this.prepareInvoice.bind(this);
    }

    prepareInvoice(data) {
        const { month, year, fetchRestaurantSalesData, setEditedEntity } = this.props;
        const { id, totalFee: amount, name: recipient, currencyCode, salesSystemId } = data;
        const text = `חודש: ${i18next.t('month' + month)}\nסך הזמנות: ${data.totalPayments}\nסך תשלומים: ${formatPrice(data.totalPaid, currencyCode, 2)}\nסך העברה - לאחר ניכוי עמלה של חברת האשראי: ${formatPrice(data.totalCalced, currencyCode, 2)}`;

        if (id && salesSystemId) {
            fetchRestaurantSalesData(id, salesSystemId, (salesInfo) => {
                if (!salesInfo.status || salesInfo.status !== "error") {
                    const { cnpj, finance_email, branch_num, bank_account } = salesInfo && salesInfo.properties || {
                        cnpj: { value: undefined },
                        finance_email: { value: undefined },
                        branch_num: { value: undefined },
                        bank_account: { value: undefined }
                    };
                    let vat = cnpj ? cnpj.value : undefined;
                    let email = finance_email ? finance_email.value : undefined;
                    let account = branch_num && bank_account ? `${branch_num.value}-${bank_account.value}` : undefined;

                    setEditedEntity('invoice', { restId: id, amount, recipient, currencyCode, text, month, year, vat, email });
                }
            });
        } else {
            setEditedEntity('invoice', { restId: id, amount, recipient, currencyCode, text, month, year });
        }
    }

    render() {
        const { paymentsReport, restaurant } = this.props;

        let totalPayments = 0;
        const totals = paymentsReport.reduce((total, row) => {
            totalPayments += row.totalPayments;

            if (!total[row.currencyCode]) {
                total[row.currencyCode] = { calced: 0, total: 0, fee: 0, tax: 0 };
            }

            if (!restaurant) {
                total[row.currencyCode].total += row.totalPaid;
                total[row.currencyCode].fee += row.totalFee;
                total[row.currencyCode].tax += row.totalFeeTax;
                total[row.currencyCode].calced += row.totalCalced;
            }

            return total;
        }, {});

        let columns = [{
            Header: i18next.t('name'),
            accessor: 'name',
            filterable: true,
            Footer: (<span>{i18next.t('total')}</span>)
        }, {
            Header: i18next.t('payments'),
            accessor: 'totalPayments',
            filterable: true,
            filterMinMax: { min: 0, max: 10000 },
            Footer: (<span>{isNaN(totalPayments) ? '' : totalPayments}</span>)
        }, {
            Header: i18next.t('amount'),
            accessor: 'totalPaid',
            Cell: row => formatPrice(row.value, row.original.currencyCode, 2),
            filterable: true,
            filterMinMax: { min: 0, max: 1000000 },
            Footer: (<span>
                {Object.keys(totals).map(currency => formatPrice(totals[currency].total, currency, 2)).join(' ')}
            </span>),
        }];

        if (!restaurant) {
            columns.push({
                Header: i18next.t('fee'),
                accessor: 'totalFee',
                Cell: row => formatPrice(row.value, row.original.currencyCode, 2),
                filterable: true,
                filterMinMax: { min: 0, max: 1000000 },
                Footer: (<span>
                    {Object.keys(totals).map(currency => formatPrice(totals[currency].fee, currency, 2)).join(' ')}
                </span>)
            });
            columns.push({
                Header: i18next.t('feeTax'),
                accessor: 'totalFeeTax',
                Cell: row => formatPrice(row.value, row.original.currencyCode, 2),
                filterable: true,
                filterMinMax: { min: 0, max: 1000000 },
                Footer: (<span>
                    {Object.keys(totals).map(currency => formatPrice(totals[currency].tax, currency, 2)).join(' ')}
                </span>)
            });
            columns.push({
                Header: i18next.t('calcedAmount'),
                accessor: 'totalCalced',
                Cell: row => formatPrice(row.value, row.original.currencyCode, 2),
                filterable: true,
                filterMinMax: { min: 0, max: 1000000 },
                Footer: (<span>
                    {Object.keys(totals).map(currency => formatPrice(totals[currency].calced, currency, 2)).join(' ')}
                </span>)
            });
            columns.push({
                id: 'actions',
                Header: i18next.t('actions'),
                maxWidth: 142,
                sortable: false,
                filterable: false,
                Cell: row => (
                    <div>
                        <Button circular size='tiny' icon='mail' primary onClick={() => this.prepareInvoice(row.original)} />
                    </div>
                )
            });
        }

        return (
                <DataGrid
                    data={paymentsReport}
                    columns={columns}
                    getTrGroupProps={(state, rowInfo, column) => {
                        if (typeof rowInfo !== "undefined") {
                            return {};
                        }
                        return {};
                    }}
                    // extraActions={this.renderDateSelection()}
                    paginated
                   
                />
        );
    }
}

RestaurantsPaymentsReport.propTypes = {
    restaurant: PropTypes.object,
    paymentsReport: PropTypes.array,
    month: PropTypes.number,
    year: PropTypes.number,
    fetchRestaurantSalesData: PropTypes.func,
    setEditedEntity: PropTypes.func,
    
};

const mapStateToProps = (state, ownProps) => {
    const paymentsReport = state.businessApp.reports.paymentsReport.map(row => ({...row, currencyCode: row.currencyCode || 'ILS'}));

    return { paymentsReport };
};

export default withRouter(connect(mapStateToProps, { fetchRestaurantSalesData, setEditedEntity })(RestaurantsPaymentsReport));